<template>

  <div class="container py-5 bg-light">
    <!-- Charts Input Component -->
    <div class="card mb-4 shadow-sm">
      <div class="card-body">
        <ComparativaIngresosGastosInput v-on:getDatosEntrada="setDatosEntrada"
          v-on:getDatosEntradaExcel="exportarExcel">
        </ComparativaIngresosGastosInput>
      </div>
    </div>

    <!-- Tabla Gastos -->
    <div class="card mb-4 shadow-sm">
      <div class="card-body">
        <h3 class="h5 fw-bold text-primary mb-3">Gastos</h3>
        <div class="table-responsive">
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th v-for="field in fields_gastos" :key="field.key">{{ field.label }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in items_gastos" :key="index">
                <td v-for="field in fields_gastos" :key="field.key">{{ item[field.key] }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Tabla Ingresos -->
    <div class="card mb-4 shadow-sm">
      <div class="card-body">
        <h3 class="h5 fw-bold text-success mb-3">Ingresos</h3>
        <div class="table-responsive">
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th v-for="field in fields_ingresos" :key="field.key">{{ field.label }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in items_ingresos" :key="index">
                <td v-for="field in fields_ingresos" :key="field.key">{{ item[field.key] }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Tabla Resumen -->
    <div class="card mb-4 shadow-sm">
      <div class="card-body">
        <h3 class="h5 fw-bold text-info mb-3">Resumen</h3>
        <div class="table-responsive">
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th v-for="field in fields_resumen" :key="field.key">{{ field.label }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in items_resumen" :key="index">
                <td v-for="field in fields_resumen" :key="field.key">{{ item[field.key] }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ComparativaIngresosGastosInput from "./inputs/ComparativaIngresosGastosInput.vue";
import { contabilidadService } from '../_services';
import { ComparativoIngresosGastosService } from '../_services';
import { BTable } from 'bootstrap-vue-3';

export default {
  name: "IngresosGastos",
  components: {
    ComparativaIngresosGastosInput, BTable
  },
  watch: {
    items_ingresos() {
      this.notifyParentOfResize();
    },
    items_gastos() {
      this.notifyParentOfResize();
    },
    items_resumen() {
      this.notifyParentOfResize();
    }
  },
  methods: {
    notifyParentOfResize() {
      const height = document.documentElement.scrollHeight;
      window.parent.postMessage({ type: 'resize', height: height }, '*');
    },
    async setDatosEntrada(parametros) {
      console.log("Setting datos de entrada...");
      console.log("Parámetros recibidos:", parametros);

      this.datosEntrada = JSON.parse(JSON.stringify(parametros)); // Desproxificar parámetros
      console.log("Datos de entrada asignados:", this.datosEntrada);

      this.datosSalida = await contabilidadService.getDatosMensuales();
      console.log("Datos de salida obtenidos:", this.datosSalida);

      // Desproxificar datos para asegurar la compatibilidad con b-table
      const datosLimpios = JSON.parse(JSON.stringify(this.datosSalida));

      this.items_ingresos = ComparativoIngresosGastosService.getIngresos(datosLimpios, this.datosEntrada);
      console.log("Items ingresos calculados:", this.items_ingresos);

      this.items_gastos = ComparativoIngresosGastosService.getGastos(datosLimpios, this.datosEntrada);
      console.log("Items gastos calculados:", this.items_gastos);

      this.items_resumen = ComparativoIngresosGastosService.getResumen(datosLimpios, this.datosEntrada);
      console.log("Items resumen calculados:", this.items_resumen);

      console.log("Llamando a setIngresos...");
      this.setIngresos();
      console.log("Campos de la tabla de ingresos:", JSON.parse(JSON.stringify(this.fields_ingresos)));

      console.log("Llamando a setGastos...");
      this.setGastos();
      console.log("Campos de la tabla de gastos:", JSON.parse(JSON.stringify(this.fields_gastos)));

      console.log("Llamando a setResumen...");
      this.setResumen();
      console.log("Campos de la tabla de resumen:", JSON.parse(JSON.stringify(this.fields_resumen)));

      console.log("setDatosEntrada completado.");
    },
    async exportarExcel(parametros) {
      console.log("Iniciando exportarExcel...");
      console.log("Parámetros para Excel:", parametros);

      // Agregar trazas para cada valor en `parametros`
      console.log("Verificando month1:", parametros.month1);
      console.log("Verificando month2:", parametros.month2);
      console.log("Verificando year1:", parametros.year1);
      console.log("Verificando year2:", parametros.year2);

      // Validar las propiedades antes de usarlas
      if (!parametros.month1 || !parametros.month1.month_id ||
        !parametros.month2 || !parametros.month2.month_id ||
        !parametros.year1 || !parametros.year1.nombre ||
        !parametros.year2 || !parametros.year2.nombre) {
        console.error("Falta alguna propiedad en los parámetros recibidos:", parametros);
        return;
      }

      // Generar el objeto de datos para la exportación
      const data = {
        "month1": parametros.month1.month_id,
        "year1": parametros.year1.nombre,
        "month2": parametros.month2.month_id,
        "year2": parametros.year2.nombre
      };
      console.log("Datos para exportar a Excel:", data);

      try {
        console.log("Iniciando llamada a contabilidadService.downloadExcel...");
        this.datosSalida = await contabilidadService.downloadExcel(data);
        console.log("Excel generado con éxito:", this.datosSalida);
      } catch (error) {
        console.error("Error al exportar a Excel:", error);
      }
    },
    async exportarExcel_antiguo(parametros) {
      console.log("Iniciando exportarExcel...");
      console.log("Parámetros para Excel:", JSON.parse(JSON.stringify(parametros)));

      const data = {
        "month1": this.datosEntrada.month1.month_id,
        "year1": this.datosEntrada.year1.nombre,
        "month2": this.datosEntrada.month2.month_id,
        "year2": this.datosEntrada.year2.nombre
      };
      console.log("Datos para exportar a Excel:", data);

      try {
        this.datosSalida = await downloadExcel(data);
        console.log("Excel generado con éxito:", this.datosSalida);
      } catch (error) {
        console.error("Error al exportar a Excel:", error);
      }
    },
    setIngresos() {
      console.log("Configurando campos para tabla de ingresos...");
      this.fields_ingresos = [
        { key: 'desc', label: 'Descripción' },
        { key: 'year1', label: this.datosEntrada.year1.nombre },
        { key: 'year2', label: this.datosEntrada.year2.nombre },
        { key: 'dif', label: 'Diferencia' },
        { key: 'var', label: '% Variación' }
      ];
      console.log("Campos de ingresos establecidos:", this.fields_ingresos);
    },
    setGastos() {
      console.log("Configurando campos para tabla de gastos...");
      this.fields_gastos = [
        { key: 'desc', label: 'Descripción' },
        { key: 'year1', label: this.datosEntrada.year1.nombre },
        { key: 'year2', label: this.datosEntrada.year2.nombre },
        { key: 'dif', label: 'Diferencia' },
        { key: 'var', label: '% Variación' }
      ];
      console.log("Campos de gastos establecidos:", this.fields_gastos);
    },
    setResumen() {
      console.log("Configurando campos para tabla de resumen...");
      this.fields_resumen = [
        { key: 'desc', label: 'Descripción' },
        { key: 'year1', label: this.datosEntrada.year1.nombre },
        { key: 'year2', label: this.datosEntrada.year2.nombre },
        { key: 'dif', label: 'Diferencia' },
        { key: 'var', label: '% Variación' }
      ];
      console.log("Campos de resumen establecidos:", this.fields_resumen);
    }
  },
  data() {
    return {
      datosEntrada: {},
      datosSalida: {},
      fields_ingresos: [],
      items_ingresos: [],
      fields_gastos: [],
      items_gastos: [],
      fields_resumen: [],
      items_resumen: []
    };
  },
  mounted() {
    console.log("Componente IngresosGastos montado.");
    this.notifyParentOfResize();
    window.addEventListener('resize', this.notifyParentOfResize);
  }
};
</script>

<style scoped>
.table {
  border-color: #dee2e6;
}

.card {
  border: 1px solid #e3e6ea;
  border-radius: 10px;
}

.card-body {
  padding: 2rem;
}

.h5 {
  color: #495057;
}

.shadow-sm {
  box-shadow: 0 .125rem .25rem rgba(0, 0, 0, 0.075) !important;
}

.text-primary {
  color: #007bff !important;
}

.text-success {
  color: #28a745 !important;
}

.text-info {
  color: #17a2b8 !important;
}
</style>
